// extracted by mini-css-extract-plugin
export default {"wrapper":"qR-z","availablePromoMessagesLabel":"rR-z","promoMessageList":"sR-z","promoMessage":"tR-z","appliedPromoMessage":"uR-z","promoMessageAmount":"vR-z"};